export default __webpack_public_path__ + "static/media/1814.64b65980.png";